// Footer.tsx
import s from './Footer.module.scss';

export function Footer() {
  return <footer className={s.root}></footer>;
}
